import { inject, Injectable } from '@angular/core';
import { HttpMainService } from '../../http-main.service';
import { Observable, Subject } from 'rxjs';
import { AdminModel } from '@itb-monorepo/models';

@Injectable({
    providedIn: 'root'
})
export class AdminsService {

    baseUrl = '/member/';
    currentAdmin: AdminModel;
    private adminIsReady$: Subject<boolean>;
  private _HttpMainService = inject(HttpMainService);

    constructor() {
        this.adminIsReady$ = new Subject<boolean>();
        this.getCurrent();
    }

    private getCurrent(): void {
        this._HttpMainService.get<AdminModel>(this.baseUrl + "v1/admins/current").subscribe((res: AdminModel) => {
            this.currentAdmin = res;
            this.adminIsReady$.next(true);
        });
    }

    adminIsReady(): Observable<boolean> {
        return this.adminIsReady$.asObservable();
    }
}
